import type { AImageProps } from '../../atoms/AImage/AImage.types';
import type { AIconSize } from '../../atoms/AIcon/AIcon.types';
import type { MButtonIconProps } from '../MButtonIcon/MButtonIcon.types';
import type { AScrimGradientProps } from '../../atoms/AScrimGradient/AScrimGradient.types';
import type { MTagProps } from '../MTag/MTag.types';
import type { MCarouselControlsType } from '../MCarouselControls/MCarouselControls.types';
import type { ResponsiveImageSpec } from '../../utils/ImageUtils';
import type { MMediaImageItem } from '../MMediaImage/MMediaImage.types';

export enum MMediaCarouselCarouselStyle {
  Standard = 'Standard',
  Compact = 'Compact',
}

export interface MMediaCarouselMediaImageItem {
  aImage?: AImageProps;
  mButtonIcon?: MButtonIconProps;
  aScrimGradient?: AScrimGradientProps;
  mTag?: MTagProps;
}

/**
 * Legacy AEM-driven slide item shape.
 * Kept for backward compatibility with existing renderer integrations.
 */
export interface MMediaImageMultiItem extends MMediaImageItem {
  logo?: string;
  aLogo32?: { brand?: string };
  mButtonIcon?: { aIcon?: { size?: string; icon?: string } };
  iconButton?: string;
}

export interface MMediaCarouselCarouselArrow {
  disabled?: boolean;
  transparent?: boolean;
}

export interface MMediaCarouselCarouselControls {
  type?: MCarouselControlsType;
  imageOverlay?: boolean;
  aIcon?: {
    size?: AIconSize;
    icon?: string;
  };
}

export interface MMediaCarouselProps extends React.HTMLAttributes<HTMLDivElement> {
  carouselStyle?: MMediaCarouselCarouselStyle;
  hover?: boolean;
  logo?: boolean;
  /**
   * New/normalized slide list.
   */
  mMediaImage?: MMediaCarouselMediaImageItem[];
  /**
   * Legacy AEM slide list.
   */
  mMediaImageMulti?: MMediaImageMultiItem[];
  /**
   * Optional responsive rendition specs for images (mobile/tablet/desktop aspect ratios).
   */
  renditionSpecs?: ResponsiveImageSpec[];
  aCarouselArrow?: MMediaCarouselCarouselArrow;
  mCarouselControls?: MMediaCarouselCarouselControls;
  className?: string;
}
